/** Standard debounce delay for all search inputs (ms) */
export const SEARCH_DEBOUNCE_MS = 300;

/** staleTime for search result queries (ms) */
export const SEARCH_STALE_TIME = 1000 * 30; // 30 seconds

/** staleTime for autocomplete/suggestion queries (ms) */
export const SEARCH_SUGGESTIONS_STALE_TIME = 1000 * 30; // 30 seconds
